// core
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Raptor
import { RaptorActionService } from '../../resources/raptor-action.service';

export interface IValidationResponse {
  is_valid: boolean | null,
  message: string
}

@Component({
  selector: 'open-raptor-validation',
  templateUrl: './raptor-validation.component.html',
  styleUrls: ['./raptor-validation.component.scss']
})

export class RaptorValidationComponent implements OnInit {
  @Input() question!: any;
  @Input() form!: FormGroup;

  questionControl: any;
  hasFormChanges = false;
  isMemberNumberValid!: boolean | undefined;
  errorHeading: string = '';
  memberValidationResponse: IValidationResponse | undefined;
  isMemberValidationExhausted: boolean | undefined = false;

  constructor(
    private raptorActionService: RaptorActionService
  ) { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);
    this.errorHeading = this.question.settings.invalid_heading;
  }

  validateBupaNumber() {
    let controlValues = this.questionControl.value;
    let numberValue = controlValues.number || '';
    let suffixValue = controlValues.suffix || '';
    let bupaMemberNumber = this.question.layout === 'bupa_mem_num' ? numberValue + '-' + suffixValue : this.form.value[this.question.key];
    
    this.raptorActionService.validateMember(this.question.settings.validation_url, bupaMemberNumber)
      .then((data) => {
        this.memberValidationResponse = {
          is_valid: data.is_valid,
          message: data.message
        };
        
        if (data.is_valid === true) {
          let patchedValue: any = {
            [this.question.key]: controlValues
          };
          if (data.member_type) {
            patchedValue[this.question.key].type = data.member_type;
          }

          this.form.patchValue(patchedValue, { emitEvent: true });
        }
      })
      .catch((error) => {
        this.memberValidationResponse = {
          is_valid: error.error.is_valid,
          message: error.error.message
        };
        if (error.status === 429) {
          this.isMemberValidationExhausted = true;
        }
      });
  }

  disableValidateButton() {
    const formValues = this.form.value.member_number;

    if (!formValues) return;

    const isButtonDisabled = !Object.values(formValues).every((value) => value !== '' && value !== null) ||
      this.isMemberValidationExhausted === true ||
      this.memberValidationResponse?.is_valid === true;
    return isButtonDisabled;
  }
}
